import { BrandUtils, LazyLoadUtils } from "../../utils/index.js";

export const loadLoyaltySection = (brandId, clientProvider) => {
  const dynamicPart = `${brandId}/${clientProvider}/`;

  return LazyLoadUtils.lazyWithFallback(
    () =>
      import(
        /* webpackChunkName: "[request]" */
        `../Brands/${dynamicPart}LoyaltySection.layout.js`
      ),
    { componentName: "loadLoyaltySection" }
  );
};

export const preload = ({ clientProvider, brandId }) => {
  if (BrandUtils.isPokerClient())
    loadLoyaltySection(brandId, clientProvider)?.preload();
};
